import { render, staticRenderFns } from "./TheNoticeBar.vue?vue&type=template&id=4582642e&"
import script from "./TheNoticeBar.vue?vue&type=script&lang=js&"
export * from "./TheNoticeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports